function killEvent(ev) {
    ev.preventDefault();
    ev.stopPropagation();
    return false;
}

export default function stopEvent(ev) {
    if (typeof ev === 'function') {
        return function (e) {
            killEvent(e);
            ev(e);
        }
    }
    return killEvent(ev);
}
